export const viewOptions = [
  {
    value: 'TAX_PROVISION',
    label: 'Tax Provision',
  },
] as const;

export enum compareScenariosPrefixes {
  empty = '',
  base = 'BASE_',
  compare = 'COMPARE_',
  variance = 'VARIANCE_'
}

export const editCyOptions = [
  {
    value: 'GAAP_IBT',
    label: 'GAAP Income/(Loss) Before Tax',
  },
  {
    value: 'G2S_PERM',
    label: 'GAAP to STAT Non-Reversing Differences',
  },
  {
    value: 'G2S_TEMP',
    label: 'GAAP to STAT Reversing Differences',
  },
] as const;


export const functionalCurrencyOption = {
  label: 'Functional Currency',
  value: '',
} as const;

export const DATA_SOURCES = {
  COPY: 'COPY',
  TLS: 'TLS',
  EMPTY: 'EMPTY',
} as const;
